var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import SelectSurveyForm from "./SelectSurveyForm";
import useUniqueId from "../../Hooks/useUniqueId";
import { AlertInfo } from "../../UI/StandardAlerts/StandardAlerts";
import SurveyService from "../../../Services/Survey.service";
import ListService from "../../../Services/Shared/List.service";
import useService from "../../Hooks/useService";
import PersonService from "../../../Services/Person.service";
const SendSurveyModal = (_a) => {
    var { regardingPerson, recipients, onSend } = _a, modalProps = __rest(_a, ["regardingPerson", "recipients", "onSend"]);
    const makeId = useUniqueId()[1];
    const [me, loadMe] = useService(PersonService.me);
    React.useEffect(() => {
        loadMe();
    }, [loadMe]);
    return me.data ? (_jsx(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Send Survey", saveButtonContents: () => "Send", defaultValue: {
            comment: `${me.data && me.data.fullName} sent ${ListService.displayWithCommasAndAnd(recipients.map((recipient) => recipient.fullName))} a survey`,
        }, handleSubmit: (state) => SurveyService.sendSurvey({
            surveyId: state.survey.id,
            regardingPersonId: regardingPerson.personId,
            recipientPersonIds: recipients.map((recipient) => recipient.personId),
            comment: state.comment,
        }).then((responses) => {
            if (onSend) {
                onSend(responses);
            }
        }), children: (useFormProps) => (_jsxs(_Fragment, { children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("recipients"), children: "To" }), _jsx("div", { id: makeId("recipients"), children: recipients.map((recipient) => recipient.fullName).join(", ") })] }), _jsx(SelectSurveyForm, Object.assign({}, useFormProps)), _jsxs("div", { className: "form-group", children: [_jsx("label", { id: makeId("commentLabel"), htmlFor: makeId("comment"), children: "Comment" }), _jsx("textarea", { "aria-labelledby": makeId("commentLabel"), id: makeId("comment"), ref: useFormProps.register, name: "comment", className: "form-control" })] }), _jsx(AlertInfo, { message: `The survey results will appear on the Surveys tab for ${regardingPerson.fullName}.` })] })) }))) : null;
};
export default SendSurveyModal;
